// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2dQfB","title":"styles_title__3N7E-","description":"styles_description__1UOQs","separator":"styles_separator__1e-sB"};